import React from 'react';
import { CATEGORY_OPTIONS, ROUTE_OPTIONS } from '../liveTrackingTypes';
import styles from './TrackingFilters.module.css';

interface TrackingFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  category: string;
  onCategoryChange: (v: string) => void;
  route: string;
  onRouteChange: (v: string) => void;
}

export const TrackingFilters: React.FC<TrackingFiltersProps> = ({
  search, onSearchChange,
  category, onCategoryChange,
  route, onRouteChange,
}) => (
  <div className={styles.bar}>
    {/* Search */}
    <div className={styles.searchWrapper}>
      <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
      </svg>
      <input
        className={styles.searchInput}
        placeholder="Search Name, Route..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>

    {/* Category */}
    <div className={styles.selectWrapper}>
      <select className={styles.select} value={category} onChange={(e) => onCategoryChange(e.target.value)}>
        {CATEGORY_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      <svg className={styles.chevron} viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 10l5 5 5-5z" />
      </svg>
    </div>

    {/* Route */}
    <div className={styles.selectWrapper}>
      <select className={styles.select} value={route} onChange={(e) => onRouteChange(e.target.value)}>
        {ROUTE_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      <svg className={styles.chevron} viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 10l5 5 5-5z" />
      </svg>
    </div>
  </div>
);
